import { AppState } from '../rootReducer';
import { SnackbarState } from './reducer';

export const getSnackbar = (state: AppState): SnackbarState => state.snackbar;
